<template>
  <div>
    <div class="head"
         :style='`width:${width.hole};height:${height.head}`'>
      <img src="../../../assets/imgs/top_title_bg.png"
           alt=""
           class="headImg"
           :style="`top:${-23*$store.state.ratio.hole}px;`">
      <div class="head-item"></div>
      <div class="head-item"
           :style="`font-size:${22*$store.state.ratio.hole}px;line-height:${70*$store.state.ratio.hole}px;padding-left:${20*$store.state.ratio.hole}px`">宁夏山谷子公司、乐香谷合作社可追溯商品中心</div>
      <div class="head-item">
        <img src="../../../assets/imgs/closeLock.png"
             @click="carousel()"
             :style="`width:${30*$store.state.ratio.width}px;height:${24*$store.state.ratio.height}px`"
             v-if='$store.state.lock' />
        <img src="../../../assets/imgs/openLock.png"
             @click="carousel()"
             :style="`width:${30*$store.state.ratio.width}px;height:${24*$store.state.ratio.height}px`"
             v-if='!$store.state.lock' />
      </div>
    </div>
    <div :style='`width:${width.hole};height:${height.hole}`'
         class="flex">
      <div class='chart'
           :style='`height:${height.hole}`'>
        <card :width='width.card'
              :height="height.card"
              name='历史扫码量'
              class="margin mgb">
          <instrumentPanel :width='width.card'
                           :height="height.slot"
                           :data='data.historyScanCode'
                           v-if='data.historyScanCode.name' />

        </card>
        <card :width='width.card'
              :height="height.card"
              name='可追溯产品扫码排行'
              class="margin mgb">
          <progressChart :width='width.card'
                         :height="height.slot"
                         :series='data.allRank'
                         v-if="data.allRank.length" />

        </card>
        <card :width='width.card'
              :height="height.card"
              name='商品赋码趋势图'
              class="margin">
          <graph :width='width.card'
                 :height="height.slot"
                 x='日'
                 y='次数'
                 :series='data.tendency'
                 v-if='data.tendency.length' />
        </card>
      </div>
      <div class='chart flexed'
           :style='`height:${height.hole}`'>

        <div class="mid-top"
             :style='`font-size:${20*$store.state.ratio.hole}px`'>可追溯商品总量</div>

        <numShow :data='data.total'
                 v-if='data.total'
                 :style='`margin-bottom:${10*$store.state.ratio.hole}px`' />
        <div :style='`height:${600*$store.state.ratio.hole}px;width:100%`'>
          <mapScatter :data='data.queryScanCodeHeatMap'
                      v-if="data.queryScanCodeHeatMap.length" />
        </div>

      </div>
      <div class='chart'
           :style='`height:${height.hole}`'>
        <card :width='width.card'
              :height="height.card"
              name="查询记录"
              class="margin mgb">
          <el-table :data="data.table"
                    :height="height.slot"
                    width='100%'
                    :style="`font-size:${12*$store.state.ratio.hole}px`">
            <el-table-column v-for="(item,index) in tableProp"
                             :key='index'
                             :prop="item.prop"
                             :label="item.label"
                             :width="item.width"
                             align='center'>
            </el-table-column>
          </el-table>
        </card>
        <card :width='width.card'
              :height="height.card"
              name="本月前五产品扫码排行"
              class="margin mgb">
          <barDiagram :barData='data.tenRank' />
        </card>
        <card :width='width.card'
              :height="height.card"
              name='可追溯商品展示'
              class="margin">
          <!-- <div class="flex">
            <div class="chart border"
                 :style="`height:${parseFloat(height.slot)/2}px;`"
                 v-for="(item,index) in data.img1"
                 :key="index">
              <img :src="item"
                   alt="">
            </div>

          </div>
          <div class="flex">
            <div class="chart border"
                 :style="`height:${parseFloat(height.slot)/2}px`"
                 v-for="(item,index) in data.img2"
                 :key="index">
              <img :src="item"
                   alt="">
            </div>
          </div> -->
          <div class="swiper-container second-one">
            <div class="swiper-wrapper">
              <div class="swiper-slide"
                   v-for="(item,index) in data.img1"
                   :key="index"
                   :style="`height:${176*$store.state.ratio.height}px`">
                <img :src="item"
                     alt=""
                     >
                   

              </div>
            </div>
          </div>
        </card>
      </div>
    </div>
  </div>

</template>
<script>
var first = true
import card from '../../../components/common/card.vue'
import numShow from '../../../components/common/NumShow.vue'
import api from '../api'
import setting from '../setting'
import Swiper from 'swiper';
import 'swiper/dist/css/swiper.min.css';
export default {
  components: {
    card, numShow
  },
  data () {
    return {
      width: {
        hole: '',
        card: "",

      },
      height: {
        hole: '',
        card: '',
        head: '',
        slot: ''
      },
      //  { prop: 'scanAddress', label: '扫码地址' }
      tableProp: [{ prop: 'productName', label: '产品', width: 100 * this.$store.state.ratio.width + 'px' }, { prop: 'scanTime', label: '扫码时间' }],
      data: {
        historyScanCode: {},
        queryScanCodeHeatMap: [],
        allRank: [],
        tenRank: [],
        img1: [],
        img2: [],
        total: 0,
        tendency: [],
        table: []
      },
      lock: true,
      options: {
        nested: true,
        loop: true,
        observer: true,
        observeParents: true,
        pagination: {
          el: '.swiper-pagination-v',
        },
        autoplay: { delay: 3000 },
      }
    }
  },
  created () {
    let self = this
    const width = document.body.clientWidth
    const height = document.body.clientHeight
    this.width.hole = width + 'px'
    this.getHeadHeight(height)
    this.height.hole = height - parseFloat(this.height.head) + 'px'
    this.getcardWidth(width, height)
    this.getdata()
    let interval = setInterval(self.getdata, setting.requestTime);
    interval
  },
  methods: {
    getcardWidth (width, height) {
      this.width.card = (width - 4) / 4 - 6 + 'px'
      this.height.card = (height - parseFloat(this.height.head) - 2) / 3 - 30 + 'px'
      this.height.slot = parseFloat(this.height.card) * 0.9 + 'px'
    },
    getHeadHeight (height) {
      this.height.head = 0.1 * height + 'px'
    },
    carousel () {
      this.$store.commit('setLock')
      this.$emit('carousel')
    },
    getdata () {
      //历史扫码量
      api.getQueryHistoryScanCode().then(res => {
        this.data.historyScanCode = res
      })
      api.getQueryScanCodeHeatMap().then(res => {
        this.data.queryScanCodeHeatMap = res
      })
      api.getQueryProductScanCode().then(res => {
        this.data.allRank = res.allRank
        this.data.tenRank = res.tenRank
        this.data.img1 = res.img1
        this.data.img2 = res.img2
        if (first) {
          let mySwiper = new Swiper('.second-one', this.options)
          mySwiper
          first = false
        }

      })
      api.getQueryTotalCode().then(res => {
        this.data.total = res
      })
      api.getQueryMonthScanCode().then(res => {
        this.data.tendency = res
      })
      api.getQueryTop20ScanCode().then(res => {
        this.data.table = res
      })
    }
  }
}
</script>
<style lang="scss" scoped>
.head {
  display: flex;
  position: relative;
  .headImg {
    position: absolute;
    width: 100%;
    height: 100%;
  }
  .head-item {
    flex: 1;
    text-align: center;
    position: relative;
    line-height: 50px;
    font-size: 18px;
    img {
      position: absolute;
      top: 35%;
      right: 3%;
    }
  }
}
.flex {
  display: flex;
  .chart {
    flex: 1;
    img {
      width: 100%;
      height: 100%;
    }
  }
  .flexed {
    flex: 2;
    .mid-top {
      text-align: center;
    }
  }
  .margin {
    margin-top: 0%;
  }
  .mgb {
    margin-bottom: 5%;
  }
}
.border {
  border: 1px solid black;
}
</style>